var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/api/feedback";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"d90f6ada0cad47c5a8317c93ead74334df661f79"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs"
import { Replay } from "@sentry/replay"

import { beforeSendBrowser, beforeSendTransaction, scrubBreadcrumb } from "./utils/sentry"

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN
const release =
  process.env.VERCEL_GIT_COMMIT_SHA ||
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ||
  `local-${Date.now()}`

if (process.env.NODE_ENV === "development") {
  console.log("[Sentry Client] Initializing with release:", release)
  console.log(
    "[Sentry Client] Environment:",
    process.env.NEXT_PUBLIC_ENVIRONMENT || process.env.NODE_ENV,
  )
  console.log("[Sentry Client] DSN present:", !!SENTRY_DSN)
}

Sentry.init({
  enabled: process.env.NODE_ENV !== "development",
  dsn: SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT || process.env.NODE_ENV,

  // Ignore errors that are definitely third-party/browser noise
  ignoreErrors: [
    // iOS WebKit bridge errors (Facebook/Instagram/TikTok in-app browsers)
    /window\.webkit\.messageHandlers/,
    /webkit\.messageHandlers/,
    // ResizeObserver - browser timing issue, not actionable
    /ResizeObserver loop/,
    // Firefox extensions
    /__firefox__/,
    // Android WebView bridge
    /Java object is gone/,
    // Browser extensions
    /chrome-extension:\/\//,
    /moz-extension:\/\//,
    /safari-extension:\/\//,
    /MetaMask/,
    /window\.ethereum/,
    /removeListener.*inpage/,
    /EmptyRanges/,
    // Google Maps API loading issues (external service)
    /Could not load "overlay"/,
    /Could not load "onion"/,
    // Generic third-party
    /top\.GLOBALS/,
    /fb_xd_fragment/,
    // Facebook in-app browser autofill injection
    /setContactAutofillValuesFromBridge/,
    /AutofillCallbackHandler/,
    // Media playback aborted by user navigation — not actionable
    /The fetching process for the media resource was aborted/,
    // Android WebView bridge method calls — not our code
    /Error invoking postEvent/,
    /Error invoking post: Method not found/,
    // Browser extension runtime errors — not our code
    /runtime\.sendMessage\(\)/,
    // React hydration errors: Sentry's inbound filter drops them anyway, and a page that
    // throws hundreds of them fills the send queue and loses the events that matter
    /Minified React error #(418|423|425)/,
  ],

  // Integrations
  integrations: [
    new Replay({
      blockAllMedia: false,
      maskAllText: true,
    }),
  ],

  // Release tracking - must match the webpack plugin
  release: release,

  replaysOnErrorSampleRate: 1.0,

  // Session Replay
  replaysSessionSampleRate: 0,

  // Performance Monitoring
  tracesSampleRate: process.env.NEXT_PUBLIC_ENVIRONMENT === "production" ? 0.1 : 1.0,

  maxBreadcrumbs: 100,

  // Drops API errors (the API reports them), scripts that aren't ours and unfinished requests;
  // strips requests and private URL parts (utils/sentry.ts)
  beforeBreadcrumb: scrubBreadcrumb,
  beforeSend: beforeSendBrowser,
  beforeSendTransaction,
})
